var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9056 8.09474C22.815 3.8381 18.0611 0 12.5 0C6.24276 0 1.74503 4.73384 0.0944138 8.09474C-0.0314713 8.35114 -0.0314713 8.64886 0.0944138 8.90526C2.18506 13.1619 6.93894 17 12.5 17C18.7573 17 23.255 12.266 24.9056 8.90526C25.0315 8.64886 25.0315 8.35114 24.9056 8.09474ZM12.5 15.1111C8.00095 15.1111 4.27075 12.2437 2.08264 8.5C4.26159 4.77166 7.98951 1.88889 12.5 1.88889C16.9987 1.88889 20.7293 4.75598 22.9174 8.5C20.7384 12.2282 17.0105 15.1111 12.5 15.1111ZM12.5 3.77778C9.8076 3.77778 7.61719 5.89614 7.61719 8.5C7.61719 11.1039 9.8076 13.2222 12.5 13.2222C15.1924 13.2222 17.3828 11.1039 17.3828 8.5C17.3828 5.89614 15.1924 3.77778 12.5 3.77778ZM12.5 11.3333C10.8847 11.3333 9.57032 10.0622 9.57032 8.5C9.57032 6.93761 10.8847 5.66667 12.5 5.66667C14.1155 5.66667 15.4297 6.93761 15.4297 8.5C15.4297 10.0622 14.1155 11.3333 12.5 11.3333Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6c36b4a110fd70341d0eec9e189ac926.svg";
export { ForwardRef as ReactComponent };